import PropTypes from 'prop-types'
import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {SimpleTable} from '../../../../common/simpleTable/SimpleTable.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../common/Icons.jsx'
import {useSelector} from 'react-redux'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import { ModalProcesProjektu,
} from '../../lib/components/modals.jsx'
import {useListaProcesuProjektu} from "../../../../../api/domain/elementyRejstru/queries/useListaProcesuProjektu.jsx";
import {useMeta} from "../../../../../api/domain/elementyRejstru/queries/useMeta.jsx";
import {createTableListaProcesuProjektu} from "../../lib/columns/tableListaProcesuProjektu.jsx";

const ViewListaProcesuProjektu = () => {
    const [currPozycja, setCurrPozycja] = useState({})
    const {rejestrId} = useParams()
    const listaPozycji = useListaProcesuProjektu(rejestrId)
    const metaDane = useMeta(rejestrId)
    const isAnulowana = metaDane.data?.item?.status === 'ANULOWANA'
    const titleName = `Lista procesu projektu o id: ${rejestrId || ''}`
    const [modalState, setModalState] = useState({
        delete: false,
        dodaj: false,
    })
    const rola = useSelector((state) => state.user.role)
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyProcess = Array.isArray(permissions) && permissions.includes('rejestr_obsluga_modyfikacja')
    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({...prev, [type]: false}))

    const handleAction = (row, type) => {
        openModal(type, row)
    }

    const allow = {
        show: {
            edit: rola === 'wp' || canModifyProcess,
        },
    }

    const modals = () => (
        <>
            <ModalProcesProjektu
                show={modalState.dodaj}
                handleClose={() => closeModal('dodaj')}
                currPozycja={{...currPozycja, id: rejestrId}}
            />
        </>
    )
    const th = () => {
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    // const td = (row) => {
    //     const allowItem = {
    //         show: {
    //             delete: true,
    //             edit: true,
    //         },
    //     }
    //     return (
    //         <>
    //             {/*<td>*/}
    //             {/*    <div className={'d-flex gap-2'}>*/}
    //             {/*        {allowItem.show.edit && (*/}
    //             {/*            <ButtonWithIcon*/}
    //             {/*                onClick={() =>*/}
    //             {/*                    handleAction({...row, rejestrId}, 'edit')*/}
    //             {/*                }*/}
    //             {/*                size={'sm'}*/}
    //             {/*                icon={<Icons.edit/>}*/}
    //             {/*                title='Edycja pozycji procesu'*/}
    //             {/*            />*/}
    //             {/*        )}*/}
    //             {/*        {allowItem.show.delete && (*/}
    //             {/*            <ButtonWithIcon*/}
    //             {/*                onClick={() =>*/}
    //             {/*                    handleAction({...row, rejestrId}, 'delete')*/}
    //             {/*                }*/}
    //
    //             {/*                variant={'danger'}*/}
    //             {/*                size={'sm'}*/}
    //             {/*                icon={<Icons.delete/>}*/}
    //             {/*                title='Usuń użytkownika z projektu'*/}
    //             {/*            />*/}
    //             {/*        )}*/}
    //             {/*    </div>*/}
    //             {/*</td>*/}
    //         </>
    //     )
    // }
    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Wszystkie projekty', to: `/${rola}/rejestr/lista`},
                    {label: titleName}
                ]}
                home
                nav
                destination={`/${rola}/rejestr/lista`}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex justify-content-end gap-3'}>
                {allow.show.edit && (
                    <ButtonWithIcon
                        size={'lg'}
                        onClick={() => handleAction({rejestrId}, 'dodaj')}
                        text={'Dodaj zdarzenie projektu'}
                        variant={'primary'}
                        icon={<Icons.add/>}
                        title='Dodaj zdarzenie projektu'
                        disabled={isAnulowana}
                    />
                )}
            </div>
            <SimpleTable
                detailKey={'oper_profile'}
                columns={createTableListaProcesuProjektu()}
                addTh={()=>null}
                addTd={()=>null}
                data={listaPozycji.data || []}
            />
        </>
    )
}

ViewListaProcesuProjektu.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaProcesuProjektu
